import Repository from './Repository';
import { LabelTypeMetadata } from '@/models/NutritionLabels/LabelTypeMetadata';
import { AxiosResponse } from 'axios';
import { MethodResult } from './ResultTypes/MethodResult';
import { NutritionCountry } from "@/models/NutritionLabels/NutritionCountry";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {FOPLabelFormatData} from "@/models/NutritionLabels/FOPLabelFormatData";
import {NutritionLabelsList} from "@/models/NutritionLabels/NutritionLabelsList";
import {SaveCustomizedLabelDataDto} from "@/models/NutritionLabels/v2/SaveCustomizedLabelDataDto";
import {LabelConfigurationResponse} from "@/models/NutritionLabels/v2/LabelConfigurationResponse";
import {LabelDownloadRequest} from "@/models/NutritionLabels/v2/LabelDownloadRequest";
import { NutritionLabelRoundingProfileValue } from "@/models/NutritionLabels/v2/enums/NutritionLabelRoundingProfile";

export const resource = '/nutritionLabels';
export const v2Url = `${process.env.VUE_APP_BASE_DOMAIN}/api/v2`;

export default {
  listNutritionCountries() : Promise<AxiosResponse<MethodResult<NutritionCountry[]>>> {
    return Repository.get<MethodResult<NutritionCountry[]>>(`${resource}/ListNutritionCountries`, { withCredentials: true });
  },
  getFrontOfPackageOptions(labelLanguage: LabelLanguage): Promise<AxiosResponse<FOPLabelFormatData[]>> {
    return Repository.get<FOPLabelFormatData[]>(
      `${resource}/GetFrontOfPackageOptions?labelLanguage=${labelLanguage}`,
      { withCredentials: true }
    );
  },
  getCautionaryFrontOfPackageOptions(labelLanguage: LabelLanguage): Promise<AxiosResponse<FOPLabelFormatData[]>> {
    return Repository.get<FOPLabelFormatData[]>(
      `${resource}/GetCautionaryFrontOfPackageOptions?labelLanguage=${labelLanguage}`,
      { withCredentials: true }
    );
  },
  listLabelsV2(
    labelTypeFilter?: LabelTypeMetadata | null,
    countryFilter?: string | null,
    roundingProfileFilter?: NutritionLabelRoundingProfileValue | null,
  ): Promise<AxiosResponse<NutritionLabelsList>> {
    const params: Record<string, string | number> = {};

    if (labelTypeFilter != null) {
      params.labelTypeFilter = labelTypeFilter;
    }

    if (countryFilter) {
      params.countryFilter = countryFilter;
    }

    if (roundingProfileFilter != null) {
      params.roundingProfileFilter = roundingProfileFilter;
    }

    return Repository.get<NutritionLabelsList>(
      resource,
      { withCredentials: true, baseURL: v2Url, params }
    );
  },
  getConfigurationOptionsForLabelV2(countryName: string, templateName: string): Promise<AxiosResponse<LabelConfigurationResponse>> {
    return Repository.get<LabelConfigurationResponse>(
      `${resource}/Configurations?countryName=${countryName}&templateName=${templateName}`,
      { withCredentials: true, baseURL: v2Url }
    );
  },
  getLabelConfigurationV2(recipeId: number): Promise<AxiosResponse<SaveCustomizedLabelDataDto>> {
    return Repository.get<SaveCustomizedLabelDataDto>(
      `${resource}/ForRecipe/${recipeId}`,
      { withCredentials: true, baseURL: v2Url }
    );
  },
  saveLabelConfigurationV2(saveData: SaveCustomizedLabelDataDto): Promise<AxiosResponse<number>> {
    return Repository.post<number>(
      `${resource}/ForRecipe/${saveData.recipeId}/Save`,
      saveData,
      { withCredentials: true, baseURL: v2Url },
    );
  },
  downloadLabelV2(renderData: LabelDownloadRequest): Promise<AxiosResponse<Blob>> {
    return Repository.post<LabelDownloadRequest, AxiosResponse<Blob>>(
      `${resource}/Download`,
      renderData,
      { withCredentials: true, baseURL: v2Url, responseType: 'blob' },
    );
  }
};
